export default "__VITE_ASSET__C21Tvb$f__"